<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Components
	import NightSchedule from '../NightModeComponents/NightSchedule.svelte';
	import NightModeListV2 from '../NightModeComponents/NightModeListV2.svelte';
	import NightModeDeviceOffAlert from '../NightModeComponents/NightModeDeviceOffAlert.svelte';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { supportsColorModeChange } from '../../../../helpers/night_mode_helpers';
	//Design system components
	import { Checkbox, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	const settings = readDeviceSettings(id);
	const category_setting = settings[device.category + 's'][device.channel];

	let props = {
		start: category_setting.night_mode.start_time,
		end: category_setting.night_mode.end_time,
		brightness: category_setting.night_mode.brightness,
	};
	$: nightMode = {
		active_between: [props.start, props.end],
		brightness: props.brightness,
	};

	let checked = category_setting.night_mode.enabled;
	let local_ip = get_local_ip(id);
	let showModal = false;

	const setNightMode = async (e?) => {
		let res;
		let data = {
			id: id,
			channel: device.channel,
			enabled: checked ? 1 : 0,
			start_time: props.start,
			end_time: props.end,
			brightness: props.brightness,
		};

		if (local_ip) {
			delete data.id;
			res = await localReq(
				device,
				`${local_ip}/settings/light/${device.channel}/night_mode`,
				'post',
				data,
			);
		} else {
			res = await postReq(`/device/${device.category}/settings/night_mode`, data);
		}

		if (res.isok) {
			devices_settings.update_devices_settings(id, settings);
			toast.open({
				type: 'success',
				title: checked
					? $format('night_mode_successfully_saved')
					: $format('night_mode_disabled'),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
	const handleToggler = async () => {
		checked = !checked;
		setNightMode();
	};
	const closeModal = () => {
		showModal = false;
	};
	const handleSave = (e) => {
		const _nightMode = { ...e.detail };
		[props.start, props.end, props.brightness] = [
			_nightMode.start,
			_nightMode.end,
			_nightMode.brightness,
		];
		setNightMode();
		closeModal();
	};
</script>

<Checkbox class="mb-s" size="m" bind:checked on:click={handleToggler} id="checkbox-j3p53sb-v2"
	>{$format('label_enable_night_mode')}</Checkbox
>
{#if supportsColorModeChange(device.type)}
	<NightModeDeviceOffAlert enabled={checked} />
{/if}
<Text class="mb-s" element="h3">{$format('active_nigthmode')}</Text>

{#key nightMode.active_between}
	<NightModeListV2 disabled={!checked} {nightMode} on:edit={() => (showModal = true)} />
{/key}

{#if showModal}
	<NightSchedule bind:showModal {props} {device} on:save={handleSave} />
{/if}
